var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAjustesMiniIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_198",
    "data-name": "Trazado 198",
    d: "M162.914,320.137h-.785a8.859,8.859,0,0,0-.879-2.122l.555-.555a1.082,1.082,0,0,0,0-1.529l-1.771-1.771a1.108,1.108,0,0,0-1.53,0l-.555.554a8.893,8.893,0,0,0-2.121-.878v-.785a1.082,1.082,0,0,0-1.081-1.081h-2.5a1.082,1.082,0,0,0-1.081,1.081v.785a8.886,8.886,0,0,0-2.122.879l-.555-.555a1.108,1.108,0,0,0-1.53,0l-1.771,1.771a1.083,1.083,0,0,0,0,1.53l.555.555a8.848,8.848,0,0,0-.879,2.122h-.785A1.082,1.082,0,0,0,143,321.217v2.5a1.082,1.082,0,0,0,1.081,1.082h.785a8.888,8.888,0,0,0,.879,2.122l-.555.555a1.083,1.083,0,0,0,0,1.53l1.771,1.771a1.107,1.107,0,0,0,1.53,0l.554-.555a8.918,8.918,0,0,0,2.122.879v.785a1.082,1.082,0,0,0,1.081,1.081h2.5a1.082,1.082,0,0,0,1.081-1.081V331.1a8.889,8.889,0,0,0,2.122-.879l.555.555a1.107,1.107,0,0,0,1.53,0l1.77-1.771a1.082,1.082,0,0,0,0-1.53l-.554-.555a8.9,8.9,0,0,0,.879-2.122h.785A1.082,1.082,0,0,0,164,323.722v-2.5A1.083,1.083,0,0,0,162.914,320.137Zm-9.419,6.222a3.889,3.889,0,1,1,3.889-3.889A3.893,3.893,0,0,1,153.5,326.359Z",
    transform: "translate(-142.996 -311.97)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAjustesMiniIcon);
export default __webpack_public_path__ + "static/media/ajustes-mini-icon.a8f3ed7eb9bad6ff9665d089dfe24766.svg";
export { ForwardRef as ReactComponent };